import type { ApiClient } from '../client';
import { LocationSearchResponseSchema, type LocationMatch } from '../schemas/locations';

// Search buildings by free-text address. The term rides the query string url-encoded; the client
// attaches the Firebase token via the Authorization header, never the URL. The server TRIMS the
// term before validating its 3–100 character bounds, so the caller sends it already trimmed and
// the two floors agree.
//
// Returns the BARE rows rather than the envelope: the read neither caps nor paginates, so `count`
// and the list's length are equal by contract, and offering two ways to read one number is how a
// «N COINCIDENCIAS» heading ends up disagreeing with the rows under it. The list is one row per
// PORTAL, so an `id` legitimately repeats — nothing here dedupes it, since two portals of one
// building are two rows an agent has to choose between.
export async function fetchLocations(client: ApiClient, query: string): Promise<LocationMatch[]> {
  const data = await client.get<unknown>(
    `/app_service/panel/v1/locations?q=${encodeURIComponent(query)}`,
  );
  return LocationSearchResponseSchema.parse(data).results;
}
